module.exports = __webpack_public_path__ + "officialStatic/img/xf.45860a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/xf.png
// module id = cUSa
// module chunks = 0